<div class="settings" [class.variant-card]="variant === 'card'" [class.self-padded]="variant === 'card' && headings">
  <!-- Floating card: Speaker first, then Microphone with its level, then Camera, then the buttons. -->
  <ng-container *ngIf="variant === 'card'; else panelLayout">
    <h2 class="device-title" *ngIf="headings">Device settings</h2>

    <ng-container *ngIf="showDevices">
      <div class="field">
        <label [attr.for]="uid + '-speaker'">Speaker</label>
        <ng-container *ngTemplateOutlet="speakerSelect"></ng-container>
      </div>

      <div class="field">
        <label [attr.for]="uid + '-mic'">Microphone</label>
        <ng-container *ngTemplateOutlet="micSelect"></ng-container>
        <ng-container *ngTemplateOutlet="meter"></ng-container>
        <p class="note" *ngIf="audioDisabled">Audio is turned off for this meeting.</p>
      </div>

      <div class="field" *ngIf="showCamera">
        <label [attr.for]="uid + '-camera'">Camera</label>
        <ng-container *ngTemplateOutlet="cameraSelect"></ng-container>
      </div>
    </ng-container>

    <ng-container *ngTemplateOutlet="effects"></ng-container>

    <div class="actions">
      <button type="button" class="pill outline" [disabled]="testing" (click)="testSpeaker()">Test speaker</button>
      <button type="button" class="pill primary" (click)="done.emit()">Done</button>
    </div>
  </ng-container>

  <!-- Side panel: unchanged order and behaviour (Microphone, level, Speaker when choosable; then Camera). -->
  <ng-template #panelLayout>
    <ng-container *ngIf="showDevices">
      <section>
        <h3 *ngIf="headings">Audio settings</h3>

        <div class="field">
          <label [attr.for]="uid + '-mic'">Microphone</label>
          <ng-container *ngTemplateOutlet="micSelect"></ng-container>
          <ng-container *ngTemplateOutlet="meter"></ng-container>
        </div>

        <div class="field" *ngIf="canChooseSpeaker">
          <label [attr.for]="uid + '-speaker'">Speaker</label>
          <ng-container *ngTemplateOutlet="speakerSelect"></ng-container>
        </div>
        <p class="note" *ngIf="audioDisabled">Audio is turned off for this meeting.</p>
      </section>

      <section *ngIf="showCamera">
        <h3 *ngIf="headings">Video settings</h3>
        <div class="field">
          <label [attr.for]="uid + '-camera'">Camera</label>
          <ng-container *ngTemplateOutlet="cameraSelect"></ng-container>
        </div>
      </section>
    </ng-container>

    <ng-container *ngTemplateOutlet="effects"></ng-container>
  </ng-template>
</div>

<ng-template #micSelect>
  <select [id]="uid + '-mic'" [disabled]="audioDisabled || !mics.length" (change)="micChange.emit(valueOf($event))">
    <option *ngIf="!mics.length" value="">No microphone found</option>
    <option *ngFor="let device of mics; let i = index; trackBy: trackDevice" [value]="device.deviceId" [selected]="device.deviceId === selectedOr(audioInputId, mics)">
      {{ label(device, i, "Microphone") }}
    </option>
  </select>
</ng-template>

<!-- The card always shows Speaker; where the browser can't route audio it is a disabled "System default". -->
<ng-template #speakerSelect>
  <select [id]="uid + '-speaker'" [disabled]="audioDisabled || !canChooseSpeaker || !speakers.length" (change)="speakerChange.emit(valueOf($event))">
    <option *ngIf="!canChooseSpeaker || !speakers.length" value="">System default</option>
    <ng-container *ngIf="canChooseSpeaker">
      <option *ngFor="let device of speakers; let i = index; trackBy: trackDevice" [value]="device.deviceId" [selected]="device.deviceId === selectedOr(audioOutputId, speakers)">
        {{ label(device, i, "Speaker") }}
      </option>
    </ng-container>
  </select>
</ng-template>

<ng-template #cameraSelect>
  <select [id]="uid + '-camera'" [disabled]="!cameras.length" (change)="cameraChange.emit(valueOf($event))">
    <option *ngIf="!cameras.length" value="">No camera found</option>
    <option *ngFor="let device of cameras; let i = index; trackBy: trackDevice" [value]="device.deviceId" [selected]="device.deviceId === selectedOr(videoInputId, cameras)">
      {{ label(device, i, "Camera") }}
    </option>
  </select>
</ng-template>

<ng-template #meter>
  <div class="level" *ngIf="level !== null" aria-hidden="true">
    <span class="level-fill" [style.width.%]="levelPercent"></span>
  </div>
</ng-template>

<ng-template #effects>
  <section class="effects-section" *ngIf="showEffects">
    <h3 *ngIf="headings">Background effects</h3>
    <p class="note" *ngIf="!blurSupported">Background effects aren't supported in this browser.</p>
    <div class="effects" *ngIf="blurSupported" role="radiogroup" aria-label="Background effects">
      <button type="button" class="effect" role="radio" [attr.aria-checked]="!blur" [class.selected]="!blur" (click)="blurChange.emit(false)">
        <span class="swatch none"><mat-icon fontSet="material-icons-outlined">block</mat-icon></span>
        <span>None</span>
      </button>
      <button type="button" class="effect" role="radio" [attr.aria-checked]="blur" [class.selected]="blur" (click)="blurChange.emit(true)">
        <span class="swatch blur"><mat-icon fontSet="material-icons-outlined">blur_on</mat-icon></span>
        <span>Blur</span>
      </button>
    </div>
  </section>
</ng-template>
